// Copyright (c) 2017 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import RegistrationDomainValues from '../state/registration-domain-values';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateDomainValues = (state, action) =>
    RegistrationDomainValues.update(state, {
        [action.property]: {
            $set: new KeyValuePairCollection(action.data)
        }
    });

export default (state = getDefaultState().registrationDomainValues, action) => {

    const actionTypes = {
        [actions.UPDATE_NEW_REGISTRATION_DOMAIN_VALUES]: updateDomainValues
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/product-registration/reducers/registration-domain-values.js